export const getTenantIdFromEnv = (): string | undefined => {
  return (
    (window as any)?._env_?.REACT_APP_TENANT_ID ??
    process.env.REACT_APP_TENANT_ID ??
    undefined
  );
};

export const getEnvVariableByKey = (varName: string): string | undefined => {
  return (window as any)?._env_?.[varName] ?? process.env[varName] ?? undefined;
};

export const isTenantInAllowlist = (allowlist: readonly string[]): boolean =>
  allowlist.includes(getTenantIdFromEnv() ?? '');
